import React from "react";
import logos from "../../assets/images/logos";
import { Section, LogosGrid, Logo } from "./HappyClients.styles";

const HappyClients = () => {
  const logoList = [
    // "pep",
    "bny",
    "merck",
    "espn",
    "sap",
    "att",
    "spectrum",
    "metlife",
    "samsung",
    "shp",
    "bacardi",
    "uniqlo",
    "rubraca",
    "winston",
    "intel",
    "say",
    "yamaha",
    "pedigree",
    "artica",
    "novartis",
    "ted",
  ];

  return (
    <section id="clients">
      <Section>
        <h2 className="title">Happy Clients</h2>
        <LogosGrid>
          {logoList.map((name) => (
            <Logo
              key={name}
              src={logos[name]}
              alt={`${name} logo`}
              loading="lazy"
            />
          ))}
        </LogosGrid>
      </Section>
    </section>
  );
};

export default HappyClients;
